// src/components/ui/Pill.jsx

export default function Pill({ children }) {
  return <span className="pill">{children}</span>;
}
